import { DEFAULT_INVALID, DEFAULT_REPLACE } from 'cyprus/constants';
import { FORMAT_TYPE } from 'cyprus/enums';
import { FormatValue, FormatValueOptions } from 'cyprus/types';
import { getLocalTimeZone, invalidDate } from 'cyprus/utils';
import moment from 'moment';

export const formatDate = (value: FormatValue, options: FormatValueOptions): string => {
  const ignore = options.ignore || [];
  const { format, utc } = options;
  const date = String(value);

  const match = ignore.includes(String(value));

  if (match) {
    return options.replace || DEFAULT_REPLACE;
  }

  if (invalidDate(value)) {
    return options.invalid || DEFAULT_INVALID;
  }

  switch (format) {
    case FORMAT_TYPE.DATE: // 06/15/2009
      if (utc) return moment(date).utc().format('MM/DD/YYYY');
      return moment(date).format('MM/DD/YYYY');
    case FORMAT_TYPE.DATE_SHORT: // 6/15/2009
      if (utc) return moment(date).utc().format('M/D/YYYY');
      return moment(date).format('M/D/YYYY');
    case FORMAT_TYPE.DATE_SHORT_YEAR: // 6/15/09
      if (utc) return moment(date).utc().format('M/D/YY');
      return moment(date).format('M/D/YY');
    // case FORMAT_TYPE.TIME: // 01:45 PM
    //   if (utc) return moment(date).utc().format('hh:mm A');
    //   return moment(date).format('hh:mm A');
    case FORMAT_TYPE.DATE_HOUR: // 01 PM
      if (utc) return moment(date).utc().format('h A');
      return moment(date).format('h A');
    case FORMAT_TYPE.DATE_WEEKDAY: // Monday
      if (utc) return moment(date).utc().format('dddd');
      return moment(date).format('dddd');
    case FORMAT_TYPE.DATE_WEEKDAY_SHORT: // Mon
      if (utc) return moment(date).utc().format('ddd');
      return moment(date).format('ddd');
    case FORMAT_TYPE.DATE_TIME: // 6/15/2009 1:45 PM
      if (utc) return moment(date).utc().format('MM/DD/YYYY hh:mm A');
      return moment(date).format('MM/DD/YYYY hh:mm A');
    case FORMAT_TYPE.DATE_TIME_SHORT: // 6/15/2009 1:45 PM
      if (utc) return moment(date).utc().format('M/D/YYYY hh:mm A');
      return moment(date).format('M/D/YYYY hh:mm A');
    case FORMAT_TYPE.DATE_TIME_SECONDS: // 6/15/2009 1:45 PM
      if (utc) return moment(date).utc().format('MM/DD/YYYY hh:mm:ss A');
      return moment(date).format('MM/DD/YYYY hh:mm:ss A');
    case FORMAT_TYPE.DATE_TIME_SHORT_SECONDS: // 6/15/2009 1:45 PM
      if (utc) return moment(date).utc().format('M/D/YYYY hh:mm:ss A');
      return moment(date).format('M/D/YYYY hh:mm:ss A');
    case FORMAT_TYPE.DATE_SHORT_TIMEZONE: // 6/15/2009 1:45:30 PM
      if (utc) return `${moment(date).utc().format('M/D/YYYY')} (UTC)`;
      return `${moment(date).format('M/D/YYYY')} (${getLocalTimeZone()})`;
    case FORMAT_TYPE.DATE_TIME_SHORT_TIMEZONE: // 6/15/2009 1:45:30 PM
      if (utc) return `${moment(date).utc().format('M/D/YYYY hh:mm A')} (UTC)`;
      return `${moment(date).format('M/D/YYYY hh:mm A')} (${getLocalTimeZone()})`;

    default:
      return date;
  }
};
